<div class="flex justify-between items-center mb-2">
  <h1 class="main-title">
    Gestión de turnos >
    <ng-container [ngSwitch]="origin">
      <span *ngSwitchCase="'shift-report'">Informe Jefe de Turno ></span>
      <span *ngSwitchCase="'daily-shift'">Novedades Diarias Jefe de Turno ></span>
      <span *ngSwitchDefault></span>
    </ng-container>
    Previsualización
  </h1>
  <ng-container *ngIf="origin === 'shift-report' || origin === 'daily-shift'">
    <a class="button button-outlined-primary button-sm" [routerLink]="['/', origin]">
      <i class="fa-solid fa-chevron-left" alt=""></i> Volver
    </a>
  </ng-container>
</div>

<div class="single-page-content">
  <div class="pb-16">
    <h2 class="main-subtitle">
      Seguridad / Calidad / Medio ambiente</h2>
    <app-table
      class="table-news table-switch"
      [columns]="tableColumns"
      [data]="flattenedData['seguridad']"
      (checkboxChange)="onCheckboxChange($event.checked, $event.id)"
    >
      <ng-template #actionTemplate let-visation>
        <div class="action-buttons">
          <button (click)="viewUpdateRecord(visation)">
            <img src="assets/icons/eye-icon.svg" alt="" />
          </button>
        </div>
      </ng-template>
    </app-table>
  </div>

  <div class="pb-16">
    <h2 class="main-subtitle">Personal (Ausentismo, Licencias Médicas)</h2>
    <app-table
      class="table-news table-switch"
      [columns]="tableColumns"
      [data]="flattenedData['personal']"
      (checkboxChange)="onCheckboxChange($event.checked, $event.id)"
    >
      <ng-template #actionTemplate let-visation>
        <div class="action-buttons">
          <button (click)="viewUpdateRecord(visation)">
            <img src="assets/icons/eye-icon.svg" alt="" />
          </button>
        </div>
      </ng-template>
    </app-table>
  </div>

  <div class="pb-16">
    <h2 class="main-subtitle">Proceso General </h2>
    <app-table
      class="table-news table-switch"
      [columns]="tableColumns"
      [data]="flattenedData['novedades']"
      (checkboxChange)="onCheckboxChange($event.checked, $event.id)"
    >
      <ng-template #actionTemplate let-visation>
        <ng-container *ngIf="origin === 'shift-report' || origin === 'daily-shift'; else defaultActions">
          <div class="action-buttons">
            <button (click)="viewUpdateRecord(visation)" title="Ver">
              <img src="assets/icons/eye-icon.svg" alt="" />
            </button>
            <button (click)="openCloneConfirmation(visation)" title="Clonar">
              <img src="assets/icons/copy-icon.svg" alt="" />
            </button>
            <button  (click)="editUpdateRecord(visation)" title="Editar">
              <img src="assets/icons/pencil-icon.svg" alt="" />
            </button>
            <button  (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
              <img src="assets/icons/trashcan-icon.svg" alt="" />
            </button>
          </div>
        </ng-container>
        <ng-template #defaultActions>
          <div class="action-buttons">
            <button (click)="viewUpdateRecord(visation)">
              <img src="assets/icons/eye-icon.svg" alt="" />
            </button>
          </div>
        </ng-template>
      </ng-template>
    </app-table>
  </div>

  <div class="pb-16">
    <h2 class="main-subtitle">Aviso de averías solicitado </h2>
    <app-table
      class="table-news table-switch"
      [columns]="tableColumns"
      [data]="flattenedData['aviso_averias']"
      (checkboxChange)="onCheckboxChange($event.checked, $event.id)"
    >
      <ng-template #actionTemplate let-visation>
        <ng-container *ngIf="origin === 'shift-report' || origin === 'daily-shift'; else defaultActions">
          <div class="action-buttons">
            <button (click)="viewUpdateRecord(visation)" title="Ver">
              <img src="assets/icons/eye-icon.svg" alt="" />
            </button>
            <button (click)="openCloneConfirmation(visation)" title="Clonar">
              <img src="assets/icons/copy-icon.svg" alt="" />
            </button>
            <button (click)="editUpdateRecord(visation)" title="Editar">
              <img src="assets/icons/pencil-icon.svg" alt="" />
            </button>
            <button (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
              <img src="assets/icons/trashcan-icon.svg" alt="" />
            </button>
          </div>
        </ng-container>
        <ng-template #defaultActions>
          <div class="action-buttons">
            <button (click)="viewUpdateRecord(visation)">
              <img src="assets/icons/eye-icon.svg" alt="" />
            </button>
          </div>
        </ng-template>
      </ng-template>
    </app-table>
  </div>

  <div class="pb-16">
    <h2 class="main-subtitle">Orden de Trabajo </h2>
    <app-table
      class="table-news table-switch"
      [columns]="tableColumns"
      [data]="flattenedData['o_t_ejecutadas']"
      (checkboxChange)="onCheckboxChange($event.checked, $event.id)"
    >
      <ng-template #actionTemplate let-visation>
        <ng-container *ngIf="origin === 'shift-report' || origin === 'daily-shift'; else defaultActions">
          <div class="action-buttons">
            <button (click)="viewUpdateRecord(visation)" title="Ver">
              <img src="assets/icons/eye-icon.svg" alt="" />
            </button>
            <button (click)="openCloneConfirmation(visation)" title="Clonar">
              <img src="assets/icons/copy-icon.svg" alt="" />
            </button>
            <button  (click)="editUpdateRecord(visation)" title="Editar">
              <img src="assets/icons/pencil-icon.svg" alt="" />
            </button>
            <button  (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
              <img src="assets/icons/trashcan-icon.svg" alt="" />
            </button>
          </div>
        </ng-container>
        <ng-template #defaultActions>
          <div class="action-buttons">
            <button (click)="viewUpdateRecord(visation)">
              <img src="assets/icons/eye-icon.svg" alt="" />
            </button>
          </div>
        </ng-template>
      </ng-template>
    </app-table>
  </div>

  <div class="pb-16">
    <h2 class="main-subtitle">Fuera de servicios </h2>
    <app-table
      class="table-news table-switch"
      [columns]="tableColumns"
      [data]="flattenedData['fuera_servicio']"
      (checkboxChange)="onCheckboxChange($event.checked, $event.id)"
    >
      <ng-template #actionTemplate let-visation>
        <ng-container *ngIf="origin === 'shift-report' || origin === 'daily-shift'; else defaultActions">
          <div class="action-buttons">
            <button (click)="viewUpdateRecord(visation)" title="Ver">
              <img src="assets/icons/eye-icon.svg" alt="" />
            </button>
            <button (click)="openCloneConfirmation(visation)" title="Clonar">
              <img src="assets/icons/copy-icon.svg" alt="" />
            </button>
            <button  (click)="editUpdateRecord(visation)" title="Editar">
              <img src="assets/icons/pencil-icon.svg" alt="" />
            </button>
            <button  (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
              <img src="assets/icons/trashcan-icon.svg" alt="" />
            </button>
          </div>
        </ng-container>
        <ng-template #defaultActions>
          <div class="action-buttons">
            <button (click)="viewUpdateRecord(visation)">
              <img src="assets/icons/eye-icon.svg" alt="" />
            </button>
          </div>
        </ng-template>
      </ng-template>
    </app-table>
  </div>
</div>



<app-confirm-popup
  *ngIf="showClonePopup"
  [message]="'¿Está seguro que deseas copiar esta novedad?'"
  (onConfirm)="confirmClone()"
  (onCancel)="closeClonePopup()">
</app-confirm-popup>